import './HomeApp.less';
import React, {useState, useEffect, useContext} from 'react';
import FeaturedCoursesSection from "./featured-courses-section/FeaturedCoursesSection";
import HeaderBanner from "./header-banner/HeaderBanner";


export default function HomeApp() {

    return <div className="home-app">
        <HeaderBanner/>
        <FeaturedCoursesSection/>
    </div>;
}
